import { plugins } from "./plugins";
import { settings } from "./settings";

export const htmlEditorStoreFeatures =
{
    plugins,
    settings
};